import { dom, library } from '@fortawesome/fontawesome-svg-core';

// BC-40: register only the icon subset actually reachable from the iconFa field
// options, the template icon classes and the brand-icon macro, instead of the
// kit's full ~694-icon set. The list is generated by
// buildchain/scripts/generate-fa-icons.mjs (run via the prebuild/predev hooks).
import { icons } from './icons.generated.js'

library.add(...icons)

// convert i tags to SVG
dom.watch({
    autoReplaceSvgRoot: document,
    observeMutationsRoot: document.body
})
